export const scenarioKey = `scenario`;
export const delayNextRequest = process.env.DELAY_NEXT_REQUEST || 5000;
export const sessionNameStorage = 'id';
export const sessionHeaderName = 'Session-Dialogue'
export const API_BASE_URL = process.env.API_BASE_URL || 'https://scaleflow-api.glenflow.com/v1/'
// export const API_BASE_URL = process.env.API_BASE_URL || 'http://localhost:3001/v1/';
